/**
 * @Author: Roni Laukkarinen
 * @Date:   2022-08-23 09:32:48
 * @Last Modified by:   Roni Laukkarinen
 * @Last Modified time: 2023-02-22 11:07:24
 */
/**
 * Air theme JavaScript.
 */

// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

// Init lazyload
// Usage example on template side when air-helper enabled:
// <?php image_lazyload_tag( get_post_thumbnail_id( $post->ID ) ); ?>
let images = document.querySelectorAll('.lazyload');
lazyload(images, {
     root: null,
     rootMargin: "0px",
     threshold: 0
});

// jQuery start
( function( $ ) {

	// Hide or show the "back to top" link
	$(window).scroll(function() {

    // Back to top
  	var offset = 300; // Browser window scroll (in pixels) after which the "back to top" link is shown
  	var offset_opacity = 1200; // Browser window scroll (in pixels) after which the link opacity is reduced
  	var scroll_top_duration = 700; // Duration of the top scrolling animation (in ms)
    var link_class = '.top';

		if( $(this).scrollTop() > offset ) {
      $( link_class ).addClass('is-visible');
    } else {
      $( link_class ).removeClass('is-visible');
    }

		if( $(this).scrollTop() > offset_opacity ) {
			$( link_class ).addClass('fade-out');
		} else {
      $( link_class ).removeClass('fade-out');
    }

	});

  // Document ready start
  $(function() {

    // Set up back to top link
    var moveTo = new MoveTo();
    var target = document.getElementById('target');
    moveTo.move(target);

    // Register a back to top trigger
    var trigger = document.getElementsByClassName('js-trigger')[0];
    moveTo.registerTrigger(trigger);

  });


  // Add shrink class if page not on top
  $(document).on("scroll", function() {

    if ($(document).scrollTop() > 5){
      $(".site").addClass("shrink");
    }
    else {
      $(".site").removeClass("shrink");
    }

  });

  // Responsive wrappers
  $(document).ready(function($) {

    // Add responsive wrappers for Youtube and Vimeon videos
    $('iframe[src*="youtube.com"],iframe[src*="vimeo.com"],iframe[src*="wistia.net"]').wrap('<div class="video-wrapper" />');

  });

  $(document).ready(function() {

    // Logo slider
    $( '.logo-slider' ).slick({
		  dots: false,
		  infinite: false,
		  speed: 300,
		  slidesToShow: 6,
		  slidesToScroll: 6,
		  autoplay: false,
		  autoplaySpeed: 2000,
		  arrows: true,
		  responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3,
		        infinite: true,
		        dots: false
		      }
		    },
		    {
		      breakpoint: 790,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3

		      }
		    },
		    {
		      breakpoint: 500,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    }

		    // You can unslick at a given breakpoint now by adding:
		    // settings: "unslick"
		    // instead of a settings object
		  ]
		});

    // Slick slider
    $('.featured-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
      accessibility: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1,
            centerMode: true,
            centerPadding: '35px'
          }
        },
        {
          breakpoint: 600,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '35px'
          }
        },
        {
          breakpoint: 420,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '20px'
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
      arrows: true,
      infinite: false,
      dots: false
    });

  });

  $(function() {

    // If html lang is fi, change facetwp-load-more text
    // Delay 2 seconds
    setTimeout(function() {
      if ($('html').is(':lang(fi)')) {
        $('.facetwp-load-more').text("Lataa lisää");
        $('.facetwp-load-more').attr('data-loading', 'Ladataan...');

        // Translate div content that has aria-label="Any"
        $('.facetwp-radio[aria-label="Any"]').text("Kaikki");
        $('.facetwp-radio[aria-label="Any"]').attr('aria-label', 'Kaikki');
      }
    }, 2000);

    document.addEventListener('facetwp-loaded', function() {

      $.each(FWP.facets, function(val, key) {

        if (FWP.facets[val].length > 0) {
          $('.facetwp-facet-' + val).addClass('facet-is-active');
        }
        else {
          $('.facetwp-facet-' + val).removeClass('facet-is-active');
        }
      });

      if ($('.facetwp-load-more').css('display') == 'none' ) {
        $('.loadmore-wrap').addClass('facetwp-load-more-no-content');
      }
      else {
        $('.loadmore-wrap').removeClass('facetwp-load-more-no-content');
      }

      if ($('html').is(':lang(fi)')) {

        $('.facetwp-radio[data-value="all"]').text("Kaikki");

      }

    });

  });

  // Magnific Popup
  $(document).ready(function() {

    // From an element with ID #popup
    $('.open-popup-link').magnificPopup({
      type:'inline',
      mainClass: 'mf-popup',
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $('.person-popup-opener').on('click keypress', function () {

      if(mya11yClick(event) === true){

        var person_popup_id = $( this ).attr('data-mf-id');
        var person_popup_content = $(person_popup_id).html();

        $.magnificPopup.open({
          items: {
            src: person_popup_content,
            type: 'inline',
            midClick: true
          }
        });

      }

    });

  });

  // Smooth scrolling
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top-100
    }, 500);
  });


  function mya11yClick(event){
      if(event.type === 'click'){
          return true;
      }
      else if(event.type === 'keypress'){
          var code = event.charCode || event.keyCode;
          if((code === 32)|| (code === 13)){
              return true;
          }
      }
      else{
          return false;
      }
  }

} )( jQuery );
